import {
  Select,
  IProps as SelectProps,
} from 'components/atoms/Select/Select.components';
import { useGetPicklistQuery } from 'services/sap';
import { catalogoPersonal, catalogoLenguage } from 'utils/helpers/dictionaries';
import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
interface TechnicalLevelSelectProps extends Omit<SelectProps, 'handleChange'> {
  handleChange: (value: { value: string; externalCode: string }) => void;
  chapter: { label_es_ES: string; externalCode: string }[];
  isLoading: boolean;
}

export default function TechnicalLevelSelect({
  handleChange,
  chapter,
  isLoading,
  ...rest
}: Readonly<TechnicalLevelSelectProps>) {

  const { setValue, getValues } = useFormContext();
  const options = chapter?.map(({ label_es_ES }) => ({
    value: label_es_ES,
    label: label_es_ES,
  }));
  useEffect(() => {
    const currentValue = getValues('growInformation.0.technicaLevel');
    if (chapter && currentValue) {
      const selectedChapter = chapter.find(({ label_es_ES }) => label_es_ES === currentValue);
      if (selectedChapter) {
        setValue('growInformation.0.idTechnicalLevelSap', selectedChapter.externalCode);
      } else {
        setValue('growInformation.0.technicaLevel', undefined);
      }
    }
    const currentValue2 = getValues('growInformation.1.technicaLevel');
    if (chapter && currentValue2) {
      const selectedChapter = chapter.find(({ label_es_ES }) => label_es_ES === currentValue2);
      if (selectedChapter) {
        setValue('growInformation.1.idTechnicalLevelSap', selectedChapter.externalCode);
      } else {
        setValue('growInformation.1.technicaLevel', undefined);
      }
    }
  }, [chapter, getValues, setValue]);
  return (
    <Select
      handleChange={(value) =>
        handleChange({
          value: value?.toString() ?? '',
          externalCode:
            chapter?.find(({ label_es_ES }) => label_es_ES === value)
              ?.externalCode ?? '',
        })
      }
      disabled={isLoading}
      options={options}
      {...rest}
    />
  );
}
